module.exports = __webpack_public_path__ + "static/media/digiskills_logo.fcc9e545.png";